import React from "react";
import './pageHome.css';

const PageHome = () => {
    return (
        <div className="homing">
            <div className="container">
                <h2>Hello World</h2>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Hic molestias numquam assumenda iure rerum iusto ex! Qui voluptas labore ea blanditiis, corrupti id cupiditate quam deserunt eligendi impedit aliquid reprehenderit!
                </p>
            </div>
        </div>
    );
};

export default PageHome;
